import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import data from 'emoji-mart/data/apple.json';
export function unifiedToNative(unified) {
  var unicodes = unified.split('-');
  var codePoints = unicodes.map(function (u) {
    return "0x".concat(u);
  });
  return String.fromCodePoint.apply(null, codePoints);
}
export var EmojiPropTypes = PropTypes.shape({
  id: PropTypes.string,
  a: PropTypes.string.isRequired,
  // Title ( Grinning Point )
  b: PropTypes.string,
  // Unified
  c: PropTypes.string,
  // Unified
  j: PropTypes.array,
  // Keywords
  l: PropTypes.array,
  // Emoticons shortcut ( 8-D )
  n: PropTypes.array //Shortnames

});
export function getEmojiTitle(emoji) {
  return emoji.a;
}
export function getEmojiNativeText(emoji) {
  return unifiedToNative(emoji.b || emoji.c);
}
export function buildEmojiSearch() {
  return data.categories.reduce(function (memo, category) {
    var emojis = category.emojis.map(function (id) {
      var emoji = data.emojis[id];
      var searchNames = [id].concat(emoji.n || []).concat(emoji.j || []);
      var searchEmoticons = emoji.l || [];
      return _objectSpread({
        id: id
      }, emoji, {
        searchNames: searchNames,
        searchEmoticons: searchEmoticons
      });
    });
    return memo.concat(emojis);
  }, []);
}

function findEmojiSearchNames(emoji, query) {
  return emoji.searchNames.find(function (s) {
    return s.includes(query);
  }) || emoji.searchEmoticons.find(function (s) {
    return s.includes(":".concat(query));
  });
}

export function buildEmojiList() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : buildEmojiSearch();

  if (query.length === 0) {
    return index;
  }

  return index.filter(function (emoji) {
    return findEmojiSearchNames(emoji, query);
  }).sort(function (a, b) {
    return findEmojiSearchNames(a, query).indexOf(query) - findEmojiSearchNames(b, query).indexOf(query);
  });
}
export function computeBottomSpace(plugins) {
  return plugins.reduce(function (memo, plugin) {
    return plugin.style && plugin.style.bottom === 0 ? memo + plugin.style.height : memo;
  }, 0);
}